import React from 'react';
import { Header } from 'layout';
import { withPlaceholder } from 'HOC';
import { useGetEtzProfileInflowOutflowByMonth } from 'hooks/api/etzProfile';
import EtzProfileNavTabs from '../components/EtzProfileNavTabs';
import EtzProfileBalance from '../components/EtzProfileBalance';
import RenderEtzProfileInflowOutflowTable from '../components/RenderEtzProfileInflowOutflowTable';
import { mapData } from './EtzProfileInflowOutflowTable.columns';

import messages from './EtzProfileInflowOutflowTable.messages';

const RenderEtzProfileInflowOutflowTableWithPlaceholders = withPlaceholder(
  RenderEtzProfileInflowOutflowTable,
);

const EtzProfileInflowOutflowTable: React.FC = () => {
  const {
    data: inflowOutflowByMonthData,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useGetEtzProfileInflowOutflowByMonth();

  const items = mapData(inflowOutflowByMonthData?.items);

  return (
    <>
      <Header title={messages.headerTitle} />
      <EtzProfileNavTabs />
      <EtzProfileBalance />
      <RenderEtzProfileInflowOutflowTableWithPlaceholders
        inflowOutflowByMonthData={inflowOutflowByMonthData}
        items={items}
        refetch={refetch}
        isRefetching={isRefetching}
        isLoading={isLoading}
        isError={isError}
        isData={!!inflowOutflowByMonthData?.context && !!items && items?.length !== 0}
      />
    </>
  );
};

export default EtzProfileInflowOutflowTable;
